<template>
  <div class="container container-fluid card my-4">
    <!-- EN TODOS LOS COMPONENTES (SPINERS Y ERRORES) --> 
    <div v-if="loading" class="spinner-container container-fluid">
      <div class="text-center pt-4">
        <h5>EDITAR USUARIO</h5>
      </div> 
      <Loading-Style/>
    </div>

    <Transition name="slide-fade">
      <div v-if="!loading" class="container">
        <div v-if="errors.length && !componentUser">
          <div class="text-center pt-4">
            <h5>EDITAR USUARIO</h5>
          </div>
          <p class="alert alert-danger text-center">
            <ul>
              <li v-for="error in errors" :key="error.mensaje">{{ error.mensaje }}</li>
            </ul>
          </p>
        </div>

        <div v-if="componentUser" class="text-left pt-4">
          <h5>EDITAR USUARIO</h5>
      
            <ModificarArma 
            :data="datosUserComponentes"
            :dataSelection="datosRolSelect"
            />

        </div>
      </div>
    
    </Transition>

  </div>
 
</template>
    
<script>
import { ref, onMounted } from 'vue'
import apiUsers from '../../apis/User'
import { selectRoles } from '../../Utils/apiUsersSelectorHelpers'
import { handleError } from '../../Utils/StatusHandler'

import ModificarArma from './forms/FormEdit'

export default {
  name: 'EditArma',
  components: {
    ModificarArma,
  },
  setup() {
    const loading = ref(true);
    const errors = ref([]);
    const id = ref('');
    const componentUser = ref(false);
    const datosUserComponentes = ref(null);
    const datosRolSelect = ref([]);

    const handleErrors = (error) => {
      handleError(error, { errors });
    };

    const cargarDatos = async () => {
      const userId = id.value; 

      try {
        const response = await apiUsers.postUser(userId);
  
        if (response) {
          datosUserComponentes.value = response.data;
        } else {
          console.error('No se encontraron datos en la respuesta.');
        }

        const roles = await selectRoles();

        if (roles) {
          datosRolSelect.value = roles;
        } else {
          console.error('No se encontraron roles');
        }

      } catch (error) {
        handleErrors(error);
        console.error(error);
      } finally {
        loading.value = false;
        componentUser.value = true;
      }
    };

    onMounted(() => {
      cargarDatos();
    });

    return {
      id,
      loading,
      errors,
      componentUser,
      datosUserComponentes,
      datosRolSelect
    }
  },
  created() {
    this.id = this.$route.params.id;
  },
}
</script>
